<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
// 更改全局弹窗的位置
/*.el-message {
  margin-top: 42vh;
}*/

.el-button--primary {
  background-color: #475aa7 !important;
  border-color: #475aa7 !important;
}
.el-input__inner:hover {
  border-color: #475aa7;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #475aa7;
}
.fictitious-people-dialog {
  .el-dialog__body {
    padding-bottom: 20px;
    padding-top: 15px;
  }
  .el-dialog__header {
    padding-bottom: 0;
  }
}
.el-dialog.width550 {
  width: 550px;
}
.el-dialog.width280 {
  width: 280px;
}
.el-popover-popup {
  padding: 0;
  // width: 140px;
  min-width: 140px;
}
* {
  margin: 0;
  padding: 0;

  scrollbar-color: #a1a1a1 #e3e3e3; /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
  -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */

  /* 以下是chrome浏览器自定义滚动条样式方式 */
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    background: #a1a1a1;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 3px;
    background: #e3e3e3;
  }
}
html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
}
#app {
  width: 100%;
  height: 100%;
  min-height: 500px;
}
.el-message-box-width {
  width: 42% !important;
  min-width: 420px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue